export const ADD_ARCHIVES = 'ADD_ARCHIVES';
export const ADD_ROLES = 'ADD_ROLES';
export const ADD_USER = 'ADD_USER';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const USER_LOGOUT = 'USER_LOGOUT';
export const START_SESSION_POLLING = 'START_SESSION_POLLING';
export const STOP_SESSION_POLLING = 'STOP_SESSION_POLLING';
export const SET_ACTIVE = 'SET_ACTIVE';
